import React, { createContext, useEffect, useState, Fragment } from 'react';
export const ResourcesContext = createContext();

class ResourcesAPI {
  
  constructor() {
    this.credentials = { "nombreUsuario": process.env.REACT_APP_SERNAPESCA_API_USERNAME|| "" , "clave": process.env.REACT_APP_SERNAPESCA_API_PASSWORD };
    this.loginURL = `${process.env.REACT_APP_SERNAPESCA_API || ""}/api-caletaenlinea/public/auth/login`;
    this.urlRegions = `${process.env.REACT_APP_SERNAPESCA_API || ""}/api-caletaenlinea/private/operaciones-caleta/busquedaRegistrosCaleta`;
    this.urlOrganizations = `${process.env.REACT_APP_SERNAPESCA_API || ""}/api-caletaenlinea/private/operaciones-caleta/busquedaOrganizaciones`;
    this.DesembarquePeriodos = `${process.env.REACT_APP_SERNAPESCA_API || ""}/api-caletaenlinea/private/operaciones-caleta/busquedaDesembarquesPeriodos`;
    // this.ifopUrl = "http://wsapirest.ifop.cl:52419/api/Recurso"
    this.ifopUrl = "https://wsrestifop.ifop.cl/api/Recurso"
    
  }
  _resolveRequest(params, token = true) {
    return new Promise((resolve, reject) => {
      try {
        const options = {
          method: params.method,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': window.localStorage.getItem('caletaenlineatokenjwt') && token ? ('Bearer ' + window.localStorage.getItem('caletaenlineatokenjwt')) : ''
          }
        }
        if (params.body) {
          options.body = JSON.stringify(params.body)
        }
        let url = params.url;
        if (params.query) {
          url += '?' + Object.keys(params.query).map((k) => {
            return k + '=' + params.query[k];
          }).join('&');
        }
        fetch(url, options)
          .then((response) => response.json())
          .then((resp) => {
            if (resp.error && (typeof resp.status == 'number') && Math.floor(resp.status / 100) != 2) {
              reject(resp);
              return;
            }
            resolve(resp);
          }).catch((err) => {
            reject(err);
          });
      } catch (err) {
        reject(err);
      }
    })
  }
  _resolveRequestWithSession(params) {
    return new Promise((resolve, reject) => {
      this.getTokenApp().then((sessionId) => {
        this._resolveRequest(params, sessionId).then(resolve).catch(reject);
      }).catch((err) => {
        reject(err);
      });
    });
  }

  getToken() {
    let tkn = window.localStorage.getItem('caletaenlineatokenjwt')
    return tkn ? true : false;
  }
  setToken(token) {
    window.localStorage.setItem('caletaenlineatokenjwt', token)
  }

  getTokenApp() {
    return this._resolveRequest({
      method: 'POST',
      url: this.loginURL,
      body: this.credentials
    });
  }

  getRegions(codigoRegion = null, codigoComuna = null, codigoCaleta = null) {
    return this._resolveRequest({
      method: 'GET',
      url: this.urlRegions,
      query: {
        codigoRegion: codigoRegion ? codigoRegion : '',
        codigoComuna: codigoComuna ? codigoComuna : '',
        codigoCaleta: codigoCaleta ? codigoCaleta : ''
      },
    });
  }
  getOrganizations(codigoRegion = null, codigoComuna = null, codigoCaleta = null) {
    return this._resolveRequest({
      method: 'GET',
      url: this.urlOrganizations,
      query: {
        codigoRegion: codigoRegion ? codigoRegion : '',
        codigoComuna: codigoComuna ? codigoComuna : '',
        codigoCaleta: codigoCaleta ? codigoCaleta : ''
      },
    });
  }
  getDesembarquesPeriodos(codigoRegion = null, codigoComuna = null, codigoCaleta = null, codigoEspecie = null) {
    return this._resolveRequest({
      method: 'GET',
      url: this.DesembarquePeriodos,
      query: {
        codigoRegion: codigoRegion ? codigoRegion : '',
        codigoComuna: codigoComuna ? codigoComuna : '',
        codigoCaleta: codigoCaleta ? codigoCaleta : '',
        codigoEspecie: codigoEspecie ? codigoEspecie : ''
      },
    });
  }
  getEspeciesByIfop(Cd_Region=0,Cd_Comuna=0,Cd_Caleta=0) {
    return this._resolveRequest({
      method: 'GET',
      url: this.ifopUrl,
      query: {
        Cd_Region: Cd_Region,
        Cd_Comuna: Cd_Comuna,
        Cd_Caleta: Cd_Caleta,
      },
    },false);
  }

}


export const ResourcesProvider = (props) => {
  const context = new ResourcesAPI();
  const [token, setToken] = useState();
  const [showApp, setShowApp] = useState(false);
  function getToken() {
    context.getTokenApp().then((result) => {
      context.setToken(result.data.accessToken)
      setShowApp(true)
    }).catch((err) => {
      console.warn(err);
    });
  }
  useEffect(() => {
    getToken();
    //setShowApp(true);
  }, [])
  return (
    <Fragment>
      {
        showApp && context.getToken() && (<ResourcesContext.Provider value={new ResourcesAPI()}>{props.children}</ResourcesContext.Provider>)
      }
    </Fragment>
  );
}; 